import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import { convertSymbolCodes } from "../Utils/utils";

const useSeo = ({ pathname }) => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: metaData = [] } = useGetProtectedApiDataQuery({
    url: "metadata",
    lang: languageType,
  });

  const meta = metaData.find(
    (item) => convertSymbolCodes(item.field_page_url) === pathname
  );

  useEffect(() => {
    if (meta) {
      const { title, field_description, field_keywords } = meta;

      // Set the page title
      document.title = `${convertSymbolCodes(title)} | NEEPCO`;

      // Set the meta description
      const metaDescription = document.querySelector(
        "meta[name='description']"
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", field_description);
      }

      // Set the meta keywords
      const keywordsMeta = document.querySelector("meta[name='keywords']");
      if (keywordsMeta) {
        keywordsMeta.setAttribute("content", field_keywords);
      }

      // Set author meta tag
      const authorMeta = document.createElement("meta");
      authorMeta.setAttribute("name", "author");
      authorMeta.setAttribute("content", "NEEPCO Team");
      document.head.appendChild(authorMeta);

      // Clean up the dynamically added author meta tag on unmount
      return () => {
        document.head.removeChild(authorMeta);
      };
    }
  }, [pathname, languageType, meta]);

  return {
    innerBannerImage: meta?.field_breadcrum_banner_image,
    innerBannerTitle: meta?.title,
  };
};

export default useSeo;
